import React from 'react';
import { LayoutRoute } from '../../layout/routes';
import withLoading from '../../helpers/withLoading';

const Lesson = withLoading(() => import('./'));

const route = <LayoutRoute path="/lesson/:slug([-\w]+)-:id([A-Za-z0-9\=]+)" component={Lesson} />;

export default route;
